import { ARC_CLAIMS } from "@/lib/data";
import { SectionHead, SHELL, Reveal } from "@/components/bits";
import { ArrowUpRight } from "lucide-react";

function Chain() {
    const nodes = [
        { label: "VERA", cls: "border-vera-gold/60 text-vera-gold2 bg-vera-gold/10" },
        { label: "USDC", cls: "border-vera-blue/50 text-[#A8D2FF] bg-vera-blue/10" },
        { label: "ARC", cls: "border-vera-blue/50 text-[#A8D2FF] bg-vera-blue/10" },
    ];
    return (
        <div className="flex flex-col md:flex-row items-stretch md:items-center gap-3 md:gap-0 mb-12" data-testid="arc-chain-visual">
            {nodes.map((n, i) => (
                <div key={n.label} className="flex flex-col md:flex-row items-stretch md:items-center flex-1 md:flex-none md:flex-1 last:flex-none">
                    <div className={`px-6 py-5 border font-mono text-xs tracking-[0.3em] text-center ${n.cls}`}>{n.label}</div>
                    {i < nodes.length - 1 && (
                        <div className="relative h-8 md:h-px w-px md:w-auto md:flex-1 md:mx-3 bg-white/10 ml-6 md:ml-0" aria-hidden="true">
                            <span
                                className="absolute left-0 top-1/2 -mt-[3px] w-1.5 h-1.5 rounded-full bg-vera-gold2 shadow-[0_0_8px_#F3D18A] animate-[packet_3s_linear_infinite]"
                                style={{ animationDelay: `${i * 0.5}s` }}
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default function ArcSection() {
    return (
        <section className="relative py-24 md:py-32 bg-vera-bg2/30 border-y border-white/10 overflow-hidden" data-testid="arc-section">
            <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-vera-blue/10 blur-[120px]" aria-hidden="true" />
            <SHELL className="relative">
                <SectionHead
                    index="07"
                    label="BUILT FOR ARC"
                    title={"THE SETTLEMENT LAYER FOR\nPROGRAMMABLE CAPITAL."}
                    sub="Arc is designed by Circle as an open Layer 1 for financial markets, real-time money movement, asset issuance and agentic economic activity."
                />
                <Reveal>
                    <Chain />
                </Reveal>
                <div className="grid sm:grid-cols-2 gap-5">
                    {ARC_CLAIMS.map((c, i) => (
                        <Reveal key={c.title} delay={i * 0.06}>
                            <div className="glass-card p-7 h-full flex flex-col group hover:border-vera-blue/40 transition-colors" data-testid={`arc-claim-${i + 1}`}>
                                <h3 className="font-mono text-[11px] tracking-[0.25em] text-vera-white mb-4">{c.title}</h3>
                                <p className="text-sm text-vera-mut leading-relaxed flex-1">{c.text}</p>
                                <a
                                    href={c.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`arc-claim-verify-${i + 1}`}
                                    className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] text-vera-gold2 hover:text-vera-gold mt-6 transition-colors"
                                >
                                    VERIFY SOURCE <ArrowUpRight className="w-3.5 h-3.5" aria-hidden="true" />
                                </a>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.1}>
                    <p className="text-[11px] text-vera-mut/60 leading-relaxed mt-10 max-w-3xl">
                        Arc is developed by Circle. VERA is an independent project building for the Arc network. No partnership or endorsement by Circle
                        is implied unless an official source is published on the Proof page.
                    </p>
                </Reveal>
            </SHELL>
        </section>
    );
}
